<template>
    <div>
        <div class="slider">
            <div class="slides">
                <!--radio buttons start-->
<!--                <input type="radio" name="radio-btn" id="radio1" checked>-->
<!--                <input type="radio" name="radio-btn" id="radio2">-->
                <!--radio buttons end-->
                <!--slide images start-->
<!--                <div class="slide first">-->
<!--                    <section class="webinar-one-speaker">-->
<!--                        <div class="container">-->
<!--                            <div class="row">-->
<!--                                <div class="col-md-12">-->
<!--                                    <div class="webinar-text">-->
<!--                                        <h1>How to get Your Dream Job</h1>-->
<!--                                        <div class="date-time">-->
<!--                                            <span class="date">8 October</span>-->
<!--                                            <span class="time">1:20 PM - 2:20 PM</span>-->
<!--                                        </div>-->
<!--                                        <p>Are you ready for your dream career? Don’t miss the upcoming webinar on “how-->
<!--                                            to get your dream job?” so that you are no longer confused and frustrated-->
<!--                                            when it comes to making your career decision. The webinar with Vishal Verma-->
<!--                                            will be live soon so register now!</p>-->
<!--                                        <router-link to="/webinar-detail?id=7B0P3kNEldvG8EG5JE8JQm14wrJXbj" class="register-btn">Register-->
<!--                                            Now <i class="fas fa-angle-double-right"></i></router-link>-->
<!--                                        <div class="share-bar">-->
<!--                                            <a target="_blank"-->
<!--                                               href="https://www.facebook.com/sharer/sharer.php?u=https://www.myecampus.in/webinar-detail?id=7B0P3kNEldvG8EG5JE8JQm14wrJXbj"-->
<!--                                               class="share-fb"><i class="fab fa-facebook-f"></i></a>-->
<!--                                            <a target="_blank"-->
<!--                                               href="https://telegram.me/share/url?url=https://www.myecampus.in/webinar-detail?id=7B0P3kNEldvG8EG5JE8JQm14wrJXbj"-->
<!--                                               class="tg-tele"><i class="fab fa-telegram-plane"></i></a>-->
<!--                                            <a target="_blank"-->
<!--                                               href="https://api.whatsapp.com/send?text=https://www.myecampus.in/webinar-detail?id=7B0P3kNEldvG8EG5JE8JQm14wrJXbj"-->
<!--                                               class="share-whatsapp"><i class="fab fa-whatsapp"></i></a>-->
<!--                                            <a target="_blank"-->
<!--                                               href="https://twitter.com/intent/tweet?text=https://www.myecampus.in/webinar-detail?id=7B0P3kNEldvG8EG5JE8JQm14wrJXbj"-->
<!--                                               class="share-twitter"><i class="fab fa-twitter"></i></a>-->
<!--                                            <a target="_blank"-->
<!--                                               href="https://www.linkedin.com/shareArticle?mini=true&amp;url=https://www.myecampus.in/webinar-detail?id=7B0P3kNEldvG8EG5JE8JQm14wrJXbj"-->
<!--                                               class="share-linkedin"><i class="fab fa-linkedin-in"></i></a>-->
<!--                                        </div>-->
<!--                                    </div>-->
<!--                                </div>-->
<!--                            </div>-->
<!--                            <div class="webinar-speaker-img">-->
<!--                                <div class="rotate-div">-->
<!--                                    <div class="speaker-img">-->
<!--                                        <img src="https://empoweryouth.com/assets/themes/ey/images/pages/webinar/vishal-verma-pic.png">-->

<!--                                    </div>-->
<!--                                    <div class="speaker-detail">-->
<!--                                        <h2>Vishal Verma</h2>-->
<!--                                        <h5>Personality Development Coach</h5>-->
<!--                                        <h5>International IELTS Trainer</h5>-->
<!--                                        <h5>National Debate Champion</h5>-->
<!--                                    </div>-->
<!--                                </div>-->
<!--                            </div>-->
<!--                        </div>-->
<!--                    </section>-->

<!--                </div>-->
                <div class="slide">

                    <section class="webinar-one-speaker1">
                        <div class="green-strip"></div>
                        <div class="green-strip"></div>
                        <div class="date-time">
                            <div class="time">
                                04:00 PM - 05:00 PM
                            </div>
                            <div class="date">
                                16 October, 2021
                            </div>
                        </div>
                        <div class="container">
                            <div class="row">
                                <div class="col-sm-5">
                                    <div class="speaker-details">
                                        <div class="speaker-image">
                                            <div class="inside-div">
                                                <img src="https://empoweryouth.com/assets/themes/ey/images/pages/webinar/vanesh-sharma-pic.png">
                                            </div>
                                        </div>
                                        <div class="speaker-name">
                                            <h5>Speaker:</h5>
                                            <h3>Vanesh Sharma</h3>
                                            <h4>Proprietary Trader</h4>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-sm-7">
                                    <div class="webinar-text">
                                        <h1>How to build long term wealth in stock market?</h1>
                                        <div class="date-time">
                                            <div class="time">
                                                <img src="https://empoweryouth.com/assets/themes/ey/images/pages/webinar/time-icon.png">4:00 PM
                                                - 5:00 PM
                                            </div>
                                            <div class="date">
                                                <img src="https://empoweryouth.com/assets/themes/ey/images/pages/webinar/calendar-icon.png">16
                                                October, 2021
                                            </div>
                                        </div>
                                        <p>The stock market is riddled with uncertainty, but certain tried-and-true
                                            principles can help investors boost their chances for long term success.
                                            Some of the more important basic investment advice includes riding winners
                                            and selling losers; avoiding the urge to chase "hot tips".</p>
                                        <router-link to="/webinar-detail?id=VagLPkqymR5k9qw7YwJMdb8K4GeY29" class="register-btn">
                                            Register Now <i class="fas fa-angle-double-right"></i>
                                        </router-link>
                                        <div class="share-bar">
                                            <a target="_blank"
                                               href="https://www.facebook.com/sharer/sharer.php?u=https://www.myecampus.in/webinar-detail?id=VagLPkqymR5k9qw7YwJMdb8K4GeY29"
                                               class="share-fb"><i class="fab fa-facebook-f"></i></a>
                                            <a target="_blank"
                                               href="https://telegram.me/share/url?url=https://www.myecampus.in/webinar-detail?id=VagLPkqymR5k9qw7YwJMdb8K4GeY29"
                                               class="tg-tele"><i class="fab fa-telegram-plane"></i></a>
                                            <a target="_blank"
                                               href="https://api.whatsapp.com/send?text=https://www.myecampus.in/webinar-detail?id=VagLPkqymR5k9qw7YwJMdb8K4GeY29"
                                               class="share-whatsapp"><i class="fab fa-whatsapp"></i></a>
                                            <a target="_blank"
                                               href="https://twitter.com/intent/tweet?text=https://www.myecampus.in/webinar-detail?id=VagLPkqymR5k9qw7YwJMdb8K4GeY29"
                                               class="share-twitter"><i class="fab fa-twitter"></i></a>
                                            <a target="_blank"
                                               href="https://www.linkedin.com/shareArticle?mini=true&amp;url=https://www.myecampus.in/webinar-detail?id=VagLPkqymR5k9qw7YwJMdb8K4GeY29"
                                               class="share-linkedin"><i class="fab fa-linkedin-in"></i></a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </section>

                </div>
                <!--slide images end-->
                <!--automatic navigation start-->
<!--                <div class="navigation-auto">-->
<!--                    <div class="auto-btn1"></div>-->
<!--                    <div class="auto-btn2"></div>-->
<!--                </div>-->
                <!--automatic navigation end-->
            </div>
            <!--manual navigation start-->
<!--            <div class="navigation-manual">-->
<!--                <label for="radio1" class="manual-btn"></label>-->
<!--                <label for="radio2" class="manual-btn"></label>-->
<!--            </div>-->
            <!--manual navigation end-->
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            counter: 1,
            countDown: null,
        }
    },
    mounted() {
        var t = this;
        // t.startSlider();
    },
    methods: {
        startSlider(){
            var t = this;
            t.countDown = setInterval(() => {
                document.getElementById('radio' + t.counter).checked = true;
                t.counter++;
                if(t.counter > 2){
                    t.counter = 1;
                }
            }, 12000)
        }
    },
    beforeDestroy () {
        // clearInterval(this.countDown);
    },
}
</script>
<style scoped>
.webinar-one-speaker {
    background: url('https://empoweryouth.com/assets/themes/ey/images/pages/webinar/webinar-one-speaker-bg.png');
    min-height: 550px;
    overflow: hidden;
    background-repeat: no-repeat;
    background-size: cover;
}
.webinar-one-speaker .container {
    min-height: 550px;
    display: flex;
    align-items: center;
    position: relative;
}
.webinar-one-speaker .row{
    position: relative;
    z-index: 2;
}
.webinar-text{
    max-width: 400px;
}
.webinar-text h1 {
    color: #fff;
    font-family: Roboto;
    text-transform: uppercase;
    font-size: 45px;
    line-height: 1.3;
    text-align: left;
}
.date-time span {
    display: block;
    line-height: 23px;
    font-family: farro;
    text-transform: uppercase;
    color: #fff;
    font-size: 20px;
    font-weight: 600;
}
.webinar-text p {
    line-height: 17px;
    color: #c0c0c0;
    margin: 22px 0 0 0;
}
a.register-btn {
    background: linear-gradient(91.16deg, #FFBB54 -43.72%, #CB650C 125.14%, #DB7E2E 125.14%);
    border-radius: 27px;
    padding: 15px 30px;
    display: inline-block;
    margin-top: 20px;
    color: #fff;
    transition: all linear .3s;
}
a.register-btn i{
    transition: all linear .3s;
}
a.register-btn:hover{
    color: #fff;
    transition: all linear .3s;
}
a.register-btn:hover i{
    margin-left: 15px;
    transition: all linear .3s;
}
.share-bar {
    margin-top: 20px;
}

.share-bar a {
    display: inline-block;
    font-size: 18px;
    color: #fff;
    width: 30px;
    border-radius: 4px;
    height: 30px;
    position: relative;
    border-radius: 10px;
    background: #FFFFFF;
    box-shadow: 0px 0px 4px rgb(0 0 0 / 25%);
    border-radius: 11px;
    transition: .2s all ease-in;
    margin-left: 10px;
}

.share-bar .fab, .share-bar .far {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
}

.share-bar a:not(.share-fb) {
    margin-left: 7px;
}

.share-bar a.share-fb {
    color: #3b5998;
}

.share-bar a.share-twitter {
    color: #1DA1F2;
}

.share-bar a.share-whatsapp {
    color: #25D366;
}
.share-bar a.share-linkedin {
    color: #0e76a8;
}

.share-bar a.tg-tele {
    color: #0088cc;
    border-color: #0088cc;
}

.share-bar a:hover {
    color: #fff;
    transition: 0.2s all ease-in;
    font-size: 12px;
    border-radius: 20px;
}

.share-bar a.share-fb:hover {
    background-color: #3b5998;
}

.share-bar a.share-twitter:hover {
    background-color: #1DA1F2;
}

.share-bar a.share-whatsapp:hover {
    background-color: #25D366;
}
.share-bar a.share-linkedin:hover {
    background-color: #0e76a8;
}

.share-bar a.tg-tele:hover {
    background-color: #0088cc;
    border-color: #0088cc;
}
.webinar-speaker-img {
    width: 70%;
    position: absolute;
    height: 100%;
    right: -200px;
    top: -76px;
    display: flex;
    align-items: center;
}
.candidate-dashboard-main-content .webinar-speaker-img {
    width: 90%;
    top: -180px;
}
.rotate-div {
    width: 100%;
    height: 250px;
    background: #323e5a;
    display: flex;
    align-items: center;
    border-radius: 140px;
    transform: rotate(-45deg) translate(30px, -120px);
}
.speaker-img {
    width: 230px;
    background: #fff;
    border-radius: 50%;
    height: 230px;
    margin-left: 10px;
}
.speaker-img img, .inside-div img {
    width: 100%;
}
.speaker-detail {
    margin-left: 20px;
}
.speaker-detail h2 {
    color: #fff;
    font-family: Roboto;
}
.speaker-detail h5 {
    color: #afafaf;
    margin: 0;
    font-weight: 600;
}
.rotate-div div {
    transform: rotate(45deg);
}

@media only screen and (max-width: 992px){
    .rotate-div{
        transform: rotate(-90deg) translate(30px, -120px);
    }
    .rotate-div div{
        transform: rotate(90deg);
    }
    .webinar-speaker-img{
        right: -260px;
    }
    .webinar-text h1{
        font-size: 35px;
    }
}
@media only screen and (max-width: 767px){
    .webinar-one-speaker{
        min-height: 750px;
        display: flex;
        align-items: center;
    }
    .webinar-speaker-img{
        right: -94px;
        top: 30px;
        align-items: flex-start;
    }
    .rotate-div{
        transform: none;
        height: 160px;
    }
    .speaker-img{
        width: 140px;
        height: 140px;
    }
    .rotate-div div{
        transform: none;
    }
    .webinar-text h1{
        max-width: 280px;
    }
    .speaker-detail h5{
        font-size: 10px;
    }
}
@media only screen and (max-width: 576px){
    .webinar-speaker-img{
        align-items: flex-end;
        top: 0;
        width: 110%;
    }
    .webinar-one-speaker .container{
        align-items: flex-start;
        margin-top: 30px;
    }
    .rotate-div{
        margin-bottom: 10px;
    }
    .webinar-text h1{
        max-width: 100%;
        font-size: 28px;
    }
    .webinar-text{
        max-width: 100%;
    }
    .rotate-div{
        height: 120px;
    }
    .speaker-img{
        width: 100px;
        height: 100px;
    }
    .webinar-one-speaker{
        min-height: 650px;
    }
}
@media only screen and (max-width: 375px){
    .webinar-speaker-img{
        right: -60px;
        width: 108%;
    }
    .rotate-div{
        height: 140px;
    }
    .speaker-img{
        width: 120px;
        height: 120px;
    }
    .webinar-one-speaker{
        min-height: 620px;
    }
    .webinar-one-speaker .container{
        min-height: 620px;
    }
}
.webinar-one-speaker1 {
    background: radial-gradient(77.06% 77.06% at 50% 50%, #999999 0%, #000000 100%);
    min-height: 550px;
    position: relative;
    overflow: hidden;
    background-repeat: no-repeat;
    background-size: cover;
    display: flex;
    align-items: center;
}
.webinar-one-speaker1 .webinar-text p{
    max-width: 400px;
}
.webinar-one-speaker1 .webinar-text h1 {
    color: #fff;
    font-family: Roboto;
    font-size: 40px;
    line-height: 1.3;
    max-width: 450px;
    text-align: left;
}
.webinar-one-speaker1 > .date-time span {
    display: block;
    line-height: 23px;
    font-family: farro;
    text-transform: uppercase;
    color: #fff;
    font-size: 20px;
    font-weight: 600;
}
.webinar-one-speaker1 .webinar-text p {
    line-height: 17px;
    color: #c0c0c0;
    margin: 22px 0 0 0;
}
.webinar-one-speaker1 a.register-btn {
    background: #78E890;
    border-radius: 27px;
    padding: 15px 30px;
    display: inline-block;
    margin-top: 20px;
    color: #fff;
    transition: all linear .3s;
}
a.register-btn i{
    transition: all linear .3s;
}
a.register-btn:hover{
    color: #fff;
    transition: all linear .3s;
}
a.register-btn:hover i{
    margin-left: 15px;
    transition: all linear .3s;
}
.share-bar {
    margin-top: 20px;
}

.share-bar a {
    display: inline-block;
    font-size: 18px;
    color: #fff;
    width: 30px;
    border-radius: 4px;
    height: 30px;
    position: relative;
    border-radius: 10px;
    background: #FFFFFF;
    box-shadow: 0px 0px 4px rgb(0 0 0 / 25%);
    border-radius: 11px;
    transition: .2s all ease-in;
    margin-left: 10px;
}

.share-bar .fab, .share-bar .far {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
}

.share-bar a:not(.share-fb) {
    margin-left: 7px;
}

.share-bar a.share-fb {
    color: #3b5998;
}

.share-bar a.share-twitter {
    color: 	#1DA1F2;
}

.share-bar a.share-whatsapp {
    color: #25D366;
}
.share-bar a.share-linkedin {
    color: #0e76a8;
}

.share-bar a.tg-tele {
    color: #0088cc;
    border-color: #0088cc;
}

.share-bar a:hover {
    color: #fff;
    transition: 0.2s all ease-in;
    font-size: 12px;
    border-radius: 20px;
}

.share-bar a.share-fb:hover {
    background-color: #3b5998;
}

.share-bar a.share-twitter:hover {
    background-color: #1DA1F2;
}

.share-bar a.share-whatsapp:hover {
    background-color: #25D366;
}
.share-bar a.share-linkedin:hover {
    background-color: #0e76a8;
}


.share-bar a.tg-tele:hover {
    background-color: #0088cc;
    border-color: #0088cc;
}
.webinar-one-speaker1 .green-strip:nth-child(2) {
    bottom: 35px;
    top: inherit;
    right: 0;
    transform: rotate(180deg);
}

.webinar-one-speaker1 .green-strip {
    width: 300px;
    height: 45px;
    background: linear-gradient(90deg, #78E890 28.66%, rgba(124, 192, 100, 0) 100%);
    position: absolute;
    top: 35px;
}
.webinar-one-speaker1 .speaker-image {
    width: 250px;
    height: 250px;
    border-radius: 50%;
    background: #1F1F1F;
    box-shadow: inset -5px 0px 15px rgb(0 0 0 / 42%), inset 5px 0px 7px rgb(141 141 141 / 35%);
    display: flex;
    align-items: center;
    justify-content: center;
    margin-left: auto;
    margin-right: 50px;
}
.webinar-one-speaker1 .inside-div {
    background: #FFFFFF;
    border: 9px solid #78E790;
    width: 70%;
    height: 70%;
    border-radius: 50%;
}
.webinar-one-speaker1 .speaker-name {
    font-family: Roboto;
}
.webinar-one-speaker1 .speaker-name h5 {
    color: #78e890;
    margin: 0;
}
.webinar-one-speaker1 .speaker-name h3 {
    color: #fff;
    margin: 0;
    font-weight: 700;
}
.webinar-one-speaker1 .speaker-name h4 {
    margin: 0;
    color: #e3e3e3;
}
.webinar-one-speaker1 > .date-time div:nth-child(2) {
    border-left: 4px solid #78e890;
}
.webinar-one-speaker1 > .date-time {
    position: absolute;
    bottom: 20px;
    display: flex;
}
.webinar-one-speaker1 > .date-time div {
    text-align: center;
    font-size: 25px;
    color: #fff;
    font-weight: 700;
    padding: 0 40px;
}
.webinar-one-speaker1 .webinar-text .date-time{
    display: none;
}
.webinar-one-speaker1 .webinar-text .speaker-name h3 {
    font-size: 17px;
}
.webinar-one-speaker1 .webinar-text .speaker-name h4 {
    font-size: 14px;
}
.webinar-one-speaker1 .webinar-text .date-time div {
    color: #fff;
    margin: 0 20px 0 0;
    color: #78e890;
    font-size: 20px;
    font-weight: 700;
}
.webinar-one-speaker1 .webinar-text .date-time img {
    margin-right: 10px;
}

@media only screen and (max-width: 767px){
    .webinar-one-speaker1 > .date-time{
        display: none;
    }
    .webinar-one-speaker1{
        min-height: 750px;
    }
    .webinar-one-speaker1 .webinar-text h1{
        font-size: 30px
    }
    .webinar-one-speaker1 .container{
        width: 80%;
    }
    .webinar-one-speaker1 .webinar-text .date-time{
        display: flex;
    }
    .speaker-name{
        text-align: right;
    }
    .webinar-text{
        max-width: 100%;
    }

    .webinar-one-speaker1 .webinar-text .date-time img{
        width: 24px;
        height: 24px;
        display: inline;
    }
}

@media only screen and (max-width: 576px){
    .webinar-one-speaker1{
        min-height: 650px;
    }
    .green-strip{
        display: none;
    }
    .speaker-image{
        margin-right: 0;
    }
    .webinar-one-speaker1 .row{
        display: flex;
        flex-direction: column-reverse;
    }
    .webinar-one-speaker1 .webinar-text .date-time{
        display: block;
    }
    .webinar-one-speaker1 .container{
        width: 100%;
    }
    .speaker-image {
        width: 120px !important;
        height: 120px !important;
    }
    .speaker-details{
        display: flex;
        align-items: center;
        justify-content: flex-start;
        margin-top: 20px;
    }
    .webinar-one-speaker1 .speaker-image{
        margin: 0 15px 0 0;
    }
    .webinar-one-speaker1 .speaker-name{
        text-align: left;
    }
}

@media only screen and (max-width: 991px){
    .webinar-one-speaker1 > .date-time div {
        font-size: 16px;
        padding: 0 20px;
    }
}
@media only screen and (max-width: 480px){
    .webinar-one-speaker1{
        min-height: 650px;
    }
    .webinar-one-speaker1 .webinar-text h1{
        font-size: 28px;
    }
    .webinar-one-speaker1 .speaker-name h4 {
        margin: 0;
        color: #e3e3e3;
        font-size: 13px;
    }
    .webinar-one-speaker1 .speaker-name h3 {
        font-size: 16px;
    }
}
.slider {
    width: 100%;
    overflow: hidden;
    margin-bottom: 50px;
}

.slides {
    width: 500%;
    display: flex;
}

.slides input {
    display: none;
}

.slide {
    width: 20%;
    transition: 2s;
}


/*css for manual slide navigation*/

.navigation-manual {
    position: absolute;
    width: 100%;
    margin-top: 10px;
    display: flex;
    justify-content: center;
}

.manual-btn {
    border: 2px solid #b7b7b7;
    padding: 5px;
    border-radius: 10px;
    cursor: pointer;
    transition: 1s;
}

.manual-btn:not(:last-child) {
    margin-right: 10px;
}

.manual-btn:hover {
    background: #b7b7b7;
}

#radio1:checked ~ .first {
    margin-left: 0;
}

#radio2:checked ~ .first {
    margin-left: -20%;
}

#radio3:checked ~ .first {
    margin-left: -40%;
}

#radio4:checked ~ .first {
    margin-left: -60%;
}

/*css for automatic navigation*/

.navigation-auto {
    position: absolute;
    display: flex;
    width: 100%;
    justify-content: center;
    margin-top: 560px;
}

.navigation-auto div {
    border: 2px solid #b7b7b7;
    padding: 5px;
    border-radius: 10px;
    transition: 1s;
}

.navigation-auto div:not(:last-child) {
    margin-right: 10px;
}

#radio1:checked ~ .navigation-auto .auto-btn1 {
    background: #b7b7b7;
}

#radio2:checked ~ .navigation-auto .auto-btn2 {
    background: #b7b7b7;
}

#radio3:checked ~ .navigation-auto .auto-btn3 {
    background: #b7b7b7;
}

#radio4:checked ~ .navigation-auto .auto-btn4 {
    background: #b7b7b7;
}

@media only screen and (max-width: 767px) {
    .navigation-auto {
        margin-top: 760px;
    }
}

@media only screen and (max-width: 576px) {
    .navigation-auto {
        margin-top: 660px;
    }
}
</style>